import { ColumnResizingContextProvider } from 'src/contexts/ColumnResizingContext/ColumnResizingContext';
import { Content } from 'src/contexts/ContentContext';
import { NoData, Table } from 'src/tables/Table';
import { ContentId } from 'src/utils/constants/contentId';
import { UserSetting } from 'src/WebApiController';

import { ReportTableV2Props } from '../ReportTableCommon/ReportTableCommon.types';
import { useReportDetailsTableV2 } from '../ReportTableCommon/useReportDetailsTableV2';
import {
  TicketGroupReportTableColumnDefContextV2,
  useTicketGroupReportTableColumnDefV2,
} from './TicketGroupReportTableColumnDefContext';

export const TicketGroupReportTableV2 = ({
  report,
  reportValueTypes,
  ...rest
}: ReportTableV2Props) => {
  return (
    <TicketGroupReportTableColumnDefContextV2
      report={report}
      reportValueTypes={reportValueTypes}
    >
      <ReportTableInternal report={report} {...rest} />
    </TicketGroupReportTableColumnDefContextV2>
  );
};

const ReportTableInternal = (props: ReportTableV2Props) => {
  const { displayedColumnsConfig = [] } =
    useTicketGroupReportTableColumnDefV2();

  const { isReportConfigEmpty, tableProps, data } = useReportDetailsTableV2({
    ...props,
    displayedColumnsConfig,
  });

  return isReportConfigEmpty ? (
    <></>
  ) : data?.length > 0 ? (
    <ColumnResizingContextProvider
      userSettingId={UserSetting.ReportTicketGroupColumnWidths}
    >
      <Table {...tableProps} />
    </ColumnResizingContextProvider>
  ) : (
    <NoData>
      <Content id={ContentId.NoReportText} />
    </NoData>
  );
};

export default TicketGroupReportTableV2;
